export const SET_IS_AUTH_ERROR_HANDLED = 'SET_IS_AUTH_ERROR_HANDLED'